
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4V4bN", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("aTnpf")).then(()=>parcelRequire('5pFC1'));

});
parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case 'prefetch':
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("jHfpZ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("bTshp"))
]).then(()=>parcelRequire('9s8yO'));

});

parcelRegister("hn7qF", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("16iPs"))
]).then(()=>parcelRequire('e8y07'));

});

parcelRegister("dZEdP", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("eTzkw"))
]).then(()=>parcelRequire('d7nkV'));

});

parcelRegister("koIBO", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("dXNlz")),
    (parcelRequire("jmEuB"))($parcel$resolve("b5rzm"))
]).then(()=>parcelRequire('kXac5'));

});

parcelRegister("66xfF", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("5MI2K"))
]).then(()=>parcelRequire('6wxEl'));

});

parcelRegister("6D88d", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("N637Y"))
]).then(()=>parcelRequire('aQbHi'));

});

parcelRegister("6Qbjv", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("kp3fT"))
]).then(()=>parcelRequire('hBGZx'));

});

parcelRegister("bxmU4", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("23sYp")),
    (parcelRequire("jmEuB"))($parcel$resolve("adhYS"))
]).then(()=>parcelRequire('iskSB'));

});

parcelRegister("iPgqq", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("23sYp")),
    (parcelRequire("jmEuB"))($parcel$resolve("a3tBI"))
]).then(()=>parcelRequire('1mAy2'));

});

parcelRegister("gULqM", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("23sYp")),
    (parcelRequire("jmEuB"))($parcel$resolve("22F8I"))
]).then(()=>parcelRequire('d5hG9'));

});

parcelRegister("79RG0", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("23sYp")),
    (parcelRequire("jmEuB"))($parcel$resolve("4By39"))
]).then(()=>parcelRequire('d0jk8'));

});

parcelRegister("4EIne", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("iy0Xz")).then(()=>parcelRequire('4BYzq'));

});

parcelRegister("7iWZp", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("dXNlz")),
    (parcelRequire("jmEuB"))($parcel$resolve("8qlyY")),
    (parcelRequire("jmEuB"))($parcel$resolve("aTnpf")),
    (parcelRequire("jmEuB"))($parcel$resolve("eT6lh"))
]).then(()=>parcelRequire('1qPDV'));

});

var $dd005b9bb0a6b5b1$exports = {};
$parcel$extendImportMap({
    "aTnpf": "ccm19.module.c3dbcd50.js",
    "bTshp": "flyout.module.277f6ef2.js",
    "8qlyY": "flyout.module.6d714d39.js",
    "16iPs": "header.module.7b42bcd1.js",
    "eTzkw": "magnificPopup.module.6e5ac8d2.js",
    "b5rzm": "modal.module.ea3756f0.js",
    "dXNlz": "modal.module.90d991be.js",
    "5MI2K": "panel.module.577fbc1d.js",
    "N637Y": "stickyButton.module.26f0a5d3.js",
    "kp3fT": "readMoreMarker.module.d4960244.js",
    "adhYS": "swiper1.module.7d637d1e.js",
    "23sYp": "swiper1.module.2dd603e6.js",
    "a3tBI": "swiper2.module.b36adfd0.js",
    "22F8I": "swiper3.module.c63c56e7.js",
    "4By39": "swiperTeam.module.821a5240.js",
    "iy0Xz": "treatmentSearch.module.e5249da4.js",
    "eT6lh": "asVideo.module.78d4a778.js"
});

// =============================================================
// IMPORTS
// =============================================================

(parcelRequire("4V4bN")).then((module)=>{
    module.init();
});

// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================
if (document.querySelector(".flyout-menu")) (parcelRequire("jHfpZ")).then((module)=>{
    module.init();
});

if (document.querySelector(".header")) (parcelRequire("hn7qF")).then((module)=>{
    module.init();
});

if (document.querySelector(".lightbox")) (parcelRequire("dZEdP")).then((module)=>{
    module.init();
});

if (document.querySelector(".modal")) (parcelRequire("koIBO")).then((module)=>{
    module.init();
});

if (document.querySelector(".panel")) (parcelRequire("66xfF")).then((module)=>{
    module.init();
});

if (document.getElementById("stickyButton")) (parcelRequire("6D88d")).then((module)=>{
    module.init();
});

if (document.querySelector(".read-more-marker")) (parcelRequire("6Qbjv")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--1")) (parcelRequire("bxmU4")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--2")) (parcelRequire("iPgqq")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--3")) (parcelRequire("gULqM")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-team")) (parcelRequire("79RG0")).then((module)=>{
    module.init();
});

if (document.querySelector(".ctype-ce_treatment_search")) (parcelRequire("4EIne")).then((module)=>{
    module.init();
});

if (document.querySelector(".js-player")) (parcelRequire("7iWZp")).then((module)=>{
    module.init();
});
 // =============================================================
 // OTHER
 // =============================================================
 // const updateHeaderHeight = () => {
 //   let headerHeight = document.querySelector("header").offsetHeight;
 //   document.querySelector("main").style.marginTop = headerHeight + "px";
 // };
 // updateHeaderHeight();
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // let attempts = 0;
 // const whenComplete = () => {
 //   if (++attempts > 30) return;
 //   if (document.readyState === "complete") {
 //     window.addEventListener("resize", function (e) {
 //       updateHeaderHeight();
 //     });
 //   } else {
 //     setTimeout(() => whenComplete(), 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (++styleAttempts > 30) return;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(() => stylesComplete(), 300);
 //   }
 // };
 // stylesComplete();


//# sourceMappingURL=as-modern.js.map
